import { H1 } from "@adfenix/alexandria";

interface PageHeaderProps {
  title: string;
}

const PageHeader = ({ title }: PageHeaderProps) => <H1>{title}</H1>;

export default PageHeader;
